const timeSeries = {
  queryState: {
    projectMetaLoadFailed: "មិនអាចផ្ទុកព័ត៌មានផែនទីបានទេ",
    mappingImageListLoadFailed: "មិនអាចផ្ទុករូបភាពបានទេ",
    mappingImageListNotLoaded: "មិនទាន់បានផ្ទុករូបភាពនៅឡើយទេ",
    issueListLoadFailed: "មិនអាចផ្ទុកបញ្ជីបញ្ហាបានទេ",
    projectNotSelected: "មិនបានបញ្ជាក់គម្រោងសម្រាប់ទាញយកទេ",
  },
  clip: {
    title: "ឧបករណ៍មុខកាត់",
    count: "សរុប {{count}}",
    addClipping: "បន្ថែមមុខកាត់",
    clippingList: "បញ្ជីមុខកាត់",
    box: "ប្រអប់",
    plane: "ប្លង់",
    boxName: "ប្រអប់ {{index}}",
    planeName: "ប្លង់ {{index}}",
    addBySurfaceClick: "បន្ថែមដោយចុចលើផ្ទៃ",
    placingHint: "ចុចលើផ្ទៃម៉ូដែលក្នុងទិដ្ឋភាព 3D",
    placingCancel: "ចុចកណ្ដុរស្ដាំ ឬ ESC ដើម្បីបោះបង់",
    limitNotice: "អាចប្រើក្នុងពេលតែមួយបានច្រើនបំផុត {{max}}",
    emptyList: "មិនទាន់មានមុខកាត់ទេ។",
    emptyListDesc: "បន្ថែមមុខកាត់ខាងលើ។",
    toggleItem: "បង្ហាញមុខកាត់",
    toggleItemNamed: "បង្ហាញ {{name}}",
    itemGroupNamed: "ការកំណត់ {{name}}",
    deleteNamed: "លុប {{name}}",
    deleteTitle: "លុបមុខកាត់",
    deleteConfirm: "លុបមុខកាត់ '{{name}}' ឬ?",
    deleteIrreversible: "មុខកាត់ដែលបានលុបមិនអាចស្ដារវិញបានទេ។",
    deleteCancel: "បោះបង់",
    deleteConfirmAction: "លុប",
    sizeLabel: "ជ្រុង",
    namePlaceholder: "ឈ្មោះផ្នែកកាត់",
    nameInputLabel: "ឈ្មោះ",
    renameNamed: "ប្ដូរឈ្មោះ {{name}}",
    renameTitle: "ប្ដូរឈ្មោះផ្នែកកាត់",
    renameConfirm: "រក្សាទុក",
    renameCancel: "បោះបង់",
    delete: "លុប",
    disabledTitle: "មុខកាត់បិទ",
    disabledDesc: "បើកកុងតាក់ដើម្បីប្រើ",
    editMode: "កែសម្រួល",
    editTooltipMain: "ចាប់អូសកំពូល·ផ្ទៃ ដើម្បីប្ដូររូបរាង",
    editTooltipSub: "បិទដើម្បីចាប់ម៉ូដែល និងផ្លាស់ទីកាមេរ៉ា",
    wireframe: "គែម",
    capFill: "បំពេញមុខកាត់",
    invert: "បញ្ច្រាស",
    save: "រក្សាទុក",
    unsavedChanges: "ការផ្លាស់ប្តូរមិនទាន់រក្សាទុក",
    loading: "កំពុងផ្ទុកបញ្ជីមុខកាត់…",
    loadFailed: "មិនអាចផ្ទុកបញ្ជីមុខកាត់បានទេ",
    retry: "ព្យាយាមម្តងទៀត",
    saveFailed: "រក្សាទុកបរាជ័យ សូមព្យាយាមម្តងទៀត។",
    horizontal: "ផ្ដេក",
    vertical: "បញ្ឈរ",
    gap: "គម្លាត",
    area: "ផ្ទៃក្រឡា",
    rotation: "បង្វិល",
    tilt: "ភាពទេរ",
    reset: "កំណត់ឡើងវិញ",
    undo: "មិនធ្វើវិញ",
    redo: "ធ្វើឡើងវិញ",
  },
  page: {
    title: "ត្រួតពិនិត្យស៊េរីពេលវេលា",
  },
  sidebar: {
    layers: "ស្រទាប់",
    projectInfo: "ព័ត៌មានគម្រោង",
    issues: "បញ្ហា",
    report: "របាយការណ៍",
  },
  modal: {
    issueInfo: "ព័ត៌មានបញ្ហា",
    crossSection: "ផ្នែកប្រភេទបន្ទាត់",
  },
  map: {
    satelliteMap: "ផែនទីផ្កាយរណប",
    viewerCount: "ចំនួនការមើល",
    imageList: "បញ្ជីរូបភាព",
    favoriteOnly: "មើលតែធាតុដែលចូលចិត្ត",
    standard: "ស្តង់ដារ",
    noImages: "មិនមានរូបភាព",
    nearbyImagesOnly: "រូបភាពត្រូវបានបង្ហាញក្នុងរង្វង់ 100 ម៉ែត្រ",
  },
  drawingTools: {
    draw: "គូរ",
    edit: "កែ",
    etc: "ផ្សេងៗ",
  },
  toolbar3d: {
    create: "បង្កើត",
    measurement: "វាស់",
    howToUse: "របៀបប្រើ",
    backgroundColor: "ផ្លាស់ប្ដូរពណ៌ផ្ទៃខាងក្រោយ",
    resetView: "កំណត់ការបង្ហាញឡើងវិញ",
  },
  mapTool: {
    tool: {
      splitView: "បំបែកអេក្រង់",
      splitViewCount: "ទិដ្ឋភាព {{count}} ផ្ទាំង",
      fullscreen: "ពេញអេក្រង់",
      exitFullscreen: "ចាកចេញពីពេញអេក្រង់",
      zoomIn: "ពង្រីក",
      zoomOut: "បង្រួម",
      marker: "ចំណុច",
      multiMarker: "ចំណុចច្រើន",
      line: "បន្ទាត់",
      polygon: "ពហុកោណ",
      rectangle: "ចតុកោណ",
      text: "អត្ថបទ",
      modify: "កែកំពូល",
      move: "ផ្លាស់ទី",
      delete: "លុប",
      distance: "វាស់ចម្ងាយ",
      orthogonal: "វាស់បញ្ឈរ",
      area: "វាស់ផ្ទៃ",
      profile: "វាស់ប្រវែងបណ្ដោយ",
      remover: "ជ័រលុបការវាស់",
      droneImage: "រូបភាពដ្រូន",
      areaCapture: "ចាប់យកតំបន់",
      annotationTitle: "បង្ហាញឈ្មោះបញ្ហា",
    },
    autoIssueName: "បញ្ហា {{n}}",
    issueLayerOn: {
      notice: "បានបើកស្រទាប់បញ្ហា",
    },
    deleteConfirm: {
      cancel: "បោះបង់",
      subtitle: 'លុបបញ្ហា "{{name}}" ឬ?',
      irreversible: "បញ្ហាដែលបានលុបមិនអាចស្ដារវិញបានទេ",
    },
  },
  messages: {
    annotationCreated: "ការបង្កើតចំណាំបានបញ្ចប់",
    annotationUpdated: "ការកែចំណាំបានបញ្ចប់",
    annotationDeleted: "ការលុបចំណាំបានបញ្ចប់",
    annotationCreateFailed: "ការបង្កើតចំណាំបានបរាជ័យ",
    annotationUpdateFailed: "ការកែចំណាំបានបរាជ័យ",
    annotationDeleteFailed: "ការលុបចំណាំបានបរាជ័យ",
    issueDeleted: "បញ្ហាបានលុប។",
    issueDeleteFailed: "ការលុបបញ្ហាបានបរាជ័យ។",
    issueDeleteFailedForUsage:
      "បញ្ហាដែលបានជ្រើសរើសកំពុងប្រើប្រាស់នៅចំណាំផ្សេង។",
    selectDateToDelete: "សូមជ្រើសរើសថ្ងៃដែលចង់លុប។",
  },
  deleteModal: {
    title: "លុបបញ្ហា",
    confirmMessage: "តើអ្នកពិតជាចង់លុបបញ្ហានេះមែនទេ?",
    delete: "លុប",
  },
  layerDeleteModal: {
    title: "លុបស្រទាប់",
    delete: "លុប",
    cancel: "បោះបង់",
    enterEditMode: "លុបស្រទាប់",
    deleteSuccess: "ស្រទាប់បានលុប។",
    deleteFailed: "ការលុបស្រទាប់បានបរាជ័យ។",
  },
  annotationVisibilityConfirm: {
    title: "ការបង្ហាញចំណាំត្រូវបានបិទ",
    subTitle:
      "ដើម្បីមើលបញ្ហាដែលបានជ្រើសរើស ត្រូវបើកការបង្ហាញចំណាំ។ តើចង់បើកទេ?",
    confirm: "បើក",
    cancel: "បោះបង់",
  },
  issue: {
    create: "បង្កើតបញ្ហា",
    filter: "ត្រង",
    empty: "មិនមានបញ្ហា",
    total: "ទាំងអស់",
    reset: "កំណត់ឡើងវិញ",
    apply: "អនុវត្ត",
    cancel: "បោះបង់",
    save: "រក្សាទុក",
    delete: "លុប",
    edit: "កែ",
    export: "នាំចេញបញ្ហា",
    exportTitle: "ជ្រើសរើសស៊េរីពេលវេលាដើម្បីវិភាគ",
    exportDescription:
      "ជ្រើសរើសស៊េរីពេលវេលាដែលចង់បាន ហើយចុចប៊ូតុងបញ្ជាក់ ដើម្បីប្រៀបធៀបការវាស់តាមកាលបរិច្ឆេទ ហើយតាមដានដំណើរការ និងការដោះស្រាយនៃបញ្ហាតាមពេលវេលា។",
    exportHint: "មានទំហំមិនទាន់បំពេញ។ សូមបំពេញព័ត៌មានទាំងអស់។",
    noData: "មិនមានទិន្នន័យស៊េរីពេលវេលា។",
    linkFailed: "ការភ្ជាប់បញ្ហាបានបរាជ័យ",
    confirm: "បញ្ជាក់",
    commentCount: "មតិយោបល់ {{count}}",
    unexportTitle: "ដកការនាំចេញបញ្ហា",
    unexportConfirm: "បញ្ហានៅថ្ងៃ {{dates}} នឹងត្រូវបានលុប។",
    unexportIrreversible:
      "បញ្ហាដែលបានលុបមិនអាចស្ដារឡើងវិញបានទេ។ ការកែសម្រួលកម្រិត និងទីតាំងនៃថ្ងៃទាំងនោះនឹងបាត់បង់ផងដែរ។",
    unexportAction: "ដកចេញ",
    applying: "កំពុងអនុវត្តការនាំចេញបញ្ហា",
    applySuccess: "ការភ្ជាប់បញ្ហាបានជោគជ័យ",
    partialFailure: "មិនអាចដំណើរការធាតុមួយចំនួនបានទេ។ ({{count}})",
  },
  form: {
    type: "ប្រភេទចំណាំ",
    name: "ឈ្មោះ",
    fontSize: "ទំហំអក្សរ",
    size: "ទំហំ (px)",
    color: "ពណ៌",
    opacity: "ភាពថ្លា",
    position: "ទីតាំង",
    lonlat: "រយៈបណ្ដោយ/រយៈទទឹង",
    xCoord: "កូអរដោនេ X",
    yCoord: "កូអរដោនេ Y",
    issue: "ប្រភេទបញ្ហា",
    category: "ស្តង់ដារចាត់ថ្នាក់",
    categoryPlaceholder: "ជ្រើសរើសស្តង់ដារ",
    grade: "កម្រិត",
    gradePlaceholder: "ជ្រើសរើស",
    memo: "កំណត់ចំណាំ",
    photo: "រូបថត",
  },
  layer: {
    noModels: "មិនមានគំរូដែលបានបង្កើត",
    orthomosaic: "រូបភាព Orthomosaic",
    dsm: "គំរូផ្ទៃ DSM",
    stratum: "ស្រទាប់ដី",
    design: "ស្រទាប់គម្រោង",
    line: "ស្រទាប់បន្ទាត់",
    longitudinal: "ផ្នែកបណ្ដោយ",
    crossSection: "ផ្នែកឆ្លង",
    crossSectionList: "បញ្ជីផ្នែកឆ្លង",
    specificCrossSection: "ផ្នែកឆ្លងជាក់លាក់",
  },
  export: {
    shootingDate: "ថ្ងៃថត",
    ground: "កម្ពស់ដី",
    plan: "កម្ពស់គម្រោង",
    stratum: "ស្រទាប់ដី",
    selectDate: "ជ្រើសរើសកាលបរិច្ឆេទ",
    selectFile: "ជ្រើសរើសឯកសារ",
    create: "បង្កើត",
    creating: "កំពុងបង្កើត...",
    alertMessage:
      "អាចប្រើបានតែឯកសារដែលដំណើរការបានបញ្ចប់ ហើយការបង្កើតឯកសារនឹងបញ្ចប់ក្នុងរយៈពេល 10 នាទីបន្ទាប់ពីការស្នើ។\nតារាងប្រមូលបង្ហូប: ប្រសិនបើមិនជ្រើសរើសកម្ពស់គម្រោង ការគណនាបរិមាណដែលនៅសល់នឹងប្រើភាពខុសគ្នារវាងកម្ពស់គម្រោងដែលបានជ្រើសរើស និងកម្ពស់ដីដ្រូន។",
    noSection: "មិនមានផ្នែកដែលបានជ្រើសរើស។",
    createStarted: "ការបង្កើតឯកសារបានចាប់ផ្ដើម។",
    notFound: "រកមិនឃើញទិន្នន័យផ្នែកឆ្លង។",
    createFailed: "ការបង្កើតឯកសារបានបរាជ័យ។",
    downloadTooltip:
      "ចុចប៊ូតុងទាញយក ដើម្បីនាំចេញព័ត៌មានផ្នែកឆ្លង\nជាឯកសារ CSV ឬទម្រង់ផ្សេងៗ។",
  },
  projectInfo: {
    title: "ព័ត៌មាន",
    edit: "កែ",
    project: "គម្រោង",
    mapping: "ការគូសផែនទី",
  },
  issueList: {
    title: "បញ្ហា",
    total: "បញ្ហាសរុប",
    create: "បង្កើតបញ្ហា",
    filter: "ត្រង",
    noIssues: "មិនមានបញ្ហាដែលបានចុះបញ្ជី",
    noFilteredIssues: "មិនមានបញ្ហាដែលបានត្រង",
    flyTo: "ផ្លាស់ទីទៅបញ្ហា",
    flyToAria: "ផ្លាស់ទីទៅបញ្ហា {{name}}",
    notInCurrentTimeSeriesTitle: "បញ្ហាមិនមាននៅក្នុងស៊េរីពេលវេលាបច្ចុប្បន្ន",
    notInCurrentTimeSeriesBody:
      "បញ្ហានេះមិនមាននៅក្នុងស៊េរីពេលវេលាបច្ចុប្បន្នទេ។ អ្នកអាចបង្កើតវានៅទីនេះដោយប្រើ 'នាំចេញបញ្ហា' ក្នុងព័ត៌មានបញ្ហា។",
    openIssueInfo: "បើកព័ត៌មានបញ្ហា",
    close: "បិទ",
  },
  layerFlyTo: {
    label: "ផ្លាស់ទីទៅប្លង់",
    aria: "ផ្លាស់ទីទៅប្លង់ {{name}}",
    blockedFar:
      "ស្រទាប់នេះនៅឆ្ងាយពីទីតាំងប្រហែល {{distance}} km ដូច្នេះមិនផ្លាស់ទីទេ។ សូមពិនិត្យប្រព័ន្ធកូអរដោនេរបស់ឯកសារ។",
    blockedUnresolvable:
      "មិនអាចកំណត់វិសាលភាពរបស់ស្រទាប់បានទេ ដូច្នេះមិនផ្លាស់ទីទេ។",
  },
  issueDetail: {
    grade: "កម្រិតបញ្ហា",
    type: "ប្រភេទបញ្ហា",
    tool: "ឧបករណ៍ចំណាំ",
    created: "ថ្ងៃបង្កើតបញ្ហា",
    updated: "ថ្ងៃកែបញ្ហា",
    creator: "ID អ្នកបង្កើតដំបូង",
    gradeTrend: "និន្នាការកម្រិតបញ្ហា",
    noDate: "មិនមានកាលបរិច្ឆេទ",
    notInTimeSeries: "បញ្ហានេះមិននៅក្នុងស៊េរីពេលវេលាស្តង់ដារដែលបានជ្រើសរើស។",
    linkToTimeSeries:
      "សូមផ្លាស់ប្ដូរស៊េរីពេលវេលាស្តង់ដារ ឬភ្ជាប់បញ្ហាទៅស៊េរីពេលវេលាស្តង់ដារ។",
  },
  measurement: {
    coordinates: "កូអរដោនេ",
    coordinatesFile: "ព័ត៌មានកូអរដោនេ",
    measurementFile: "ព័ត៌មានការវាស់",
    volumeFile: "ព័ត៌មានបរិមាណ",
    line: "ព័ត៌មានបន្ទាត់",
  },
  transferList: {
    timeSeriesList: "បញ្ជីស៊េរីពេលវេលា",
    selectedTimeSeries: "ស៊េរីពេលវេលាដែលបានជ្រើសរើស",
    selectAll: "ជ្រើសរើសទាំងអស់",
    standard: "ស្តង់ដារ",
    export: "នាំចេញ",
  },
  issueTypeModal: {
    title: "គ្រប់គ្រងប្រភេទបញ្ហា",
    close: "បិទ",
    searchPlaceholder: "សូមបញ្ចូលពាក្យស្វែងរក",
    addType: "បន្ថែមប្រភេទ",
    issueName: "ឈ្មោះបញ្ហា",
    add: "បន្ថែម",
    enterName: "សូមបញ្ចូលឈ្មោះប្រភេទបញ្ហា។",
    typeAdded: "ប្រភេទបញ្ហាថ្មីបានបន្ថែម។",
    addFailed: "ការបន្ថែមប្រភេទបញ្ហាបានបរាជ័យ។",
  },
  profile: {
    title: "ព្រំដែន",
    close: "បិទ",
    resetView: "កំណត់ការបង្ហាញឡើងវិញ",
    overflowMenu: "បន្ថែមទៀត",
    copyCoordinate: "ចម្លងកូអរដោនេ",
    copied: "បានចម្លង",
    copyFailed: "មិនអាចចម្លងបាន",
    copyHint: "ចុចលើក្រាហ្វដើម្បីខ្ទាស់កូអរដោនេសម្រាប់ចម្លង",
    fullscreen: "ពេញអេក្រង់",
    exitFullscreen: "ចេញពីពេញអេក្រង់",
    themeToggleToLight: "ស្បែករចនាបទភ្លឺ",
    themeToggleToDark: "ស្បែករចនាបទងងឹត",
    labelMode: {
      prefix: "ស្លាក",
      hover: "ហូវ",
      on: "ថេរ",
      tooltipHover: "បង្ហាញស្លាកពេលហូវ",
      tooltipOn: "បង្ហាញស្លាកថេរ",
    },
    opacity: {
      label: "ភាពថ្លានៃបង្អួច",
      tooltip: "កែភាពថ្លានៃបង្អួច",
    },
    colorMode: {
      prefix: "ពណ៌",
      model: "គំរូ",
      real: "ពិតប្រាកដ",
      tooltipModel: "បង្ហាញគំរូនីមួយៗជាមួយពណ៌ប្លែក",
      tooltipReal: "បង្ហាញជាមួយពណ៌ដើមនៃគំរូ 3D",
    },
    colorModes: {
      realistic: "ពិតប្រាកដ",
      model: "គំរូ",
      modelByModel: "ម្នាក់ៗ",
      comingSoon: "coming soon",
    },
    capture: {
      tooltip: "ថតរូបភាព",
      formats: {
        png: "PNG",
        jpg: "JPG",
        jpeg: "JPEG",
        webp: "WEBP",
      },
    },
    measureTools: {
      point: "វាស់ចំណុច",
      polyline: "វាស់បន្ទាត់ (ចុចបន្ថែមចំណុច ចុចស្ដាំបញ្ជាក់)",
      axes: "វាស់អ័ក្ស (វាស់ចំណុចប្រសព្វបណ្ដោយ/ឆ្លង)",
      rectangle: "វាស់ក្រឡាចត្រង្គ",
      circle: "វាស់រង្វង់",
      erase: "លុបការវាស់",
      eraseSelect: "ជ្រើសរើសលុប",
      eraseSelectHint: "ចុចចំណុច/រូបភាព/ស្លាកដើម្បីលុបម្ដងៗ",
      eraseAll: "លុបទាំងអស់",
      eraseAllHint: "លុបការវាស់ទាំងអស់នៅក្នុងក្រាហ្វព្រំដែន",
    },
    colorModePopover: {
      title: "របៀបពណ៌",
      realisticHint: "បង្ហាញពណ៌ដើមដូចដែលបានថតផ្ទាល់។",
      modelHint: "បង្ហាញគំរូនីមួយៗជាមួយពណ៌ប្លែក។ អាចប្រើតម្រងគំរូ។",
    },
    modelFilter: {
      title: "តម្រងគំរូ",
      modeOnly: "អាចប្រើបានតែក្នុងរបៀបម្នាក់ៗ។",
      empty: "មិនមានគំរូដើម្បីបង្ហាញ។",
    },
    modelLegend: {
      ariaList: "សំណាញ់ពណ៌គំរូ",
      toggleHide: "លាក់ផ្នែក",
      toggleShow: "បង្ហាញផ្នែក",
    },
    axis: {
      distance: "ចម្ងាយ (ម)",
      orthoHeight: "កម្ពស់ (ម)",
      deltaHeight: "Δកម្ពស់",
      deltaDistance: "Δចម្ងាយ",
    },
    coordinateLabels: {
      longitude: "រយៈបណ្ដោយ",
      latitude: "រយៈទទឹង",
      ellipsoidHeight: "កម្ពស់ Ellipsoid",
    },
    coordSystemWarning: {
      unsupportedEpsg:
        "គម្រោងប្រព័ន្ធកូអរដោនេដែលមិនគាំទ្រ (EPSG:{epsg})។ មិនអាចប្រើការបង្ហាញកូអរដោនេ KOREA2000 បាន។",
    },
    loading: {
      capturing: "កំពុងបង្កើតផ្នែក...",
      captureFailed: "ការផ្ទុករូបភាពផ្នែកបានបរាជ័យ",
    },
    empty: {
      noIntersection: "រកមិនឃើញគំរូ BIM/Mesh ដែលប្រសព្វនឹងផ្នែក។",
    },
    metrics: {
      sharpness: "ភាពច្បាស់",
      accuracy: "ភាពត្រឹមត្រូវ",
      confidence: "ភាពជឿជាក់",
      tooltips: {
        sharpness:
          "ទំហំ pixel នៃរូបភាពផ្នែក។ តម្លៃខ្ពស់ជាងមានន័យថាច្បាស់ជាងពេលធ្វើ zoom ។ មិនទាក់ទងនឹងភាពត្រឹមត្រូវការវាស់ ហើយប្រែប្រួលតាម DPR ការបង្ហាញ និងទំហំបន្ទះ។",
        accuracy:
          "ដែនកំណត់ការវាស់ទ្រឹស្ដីដោយផ្អែកលើ GSD នៃគំរូ 3D គម្រោង។ មកពីភាពដោះស្រាយ pixel នៃគំរូផ្ទាល់ខ្លួន។",
        confidence:
          "ជួររំខានដែលអាចទុកចិត្តបានពេលវាស់ជាក់ស្ដែង។ ប្រមាណប្រហែល 2 ដងនៃ GSD ។",
      },
    },
    fullExport: {
      currentStation: "ទាញយកស្ថានីយបច្ចុប្បន្ន",
      currentStationDescription: "ទាញយកស្ថានីយបច្ចុប្បន្ន ១ ភ្លាមៗ។",
      allStationsTitle: "ទាញយកស្ថានីយទាំងអស់",
      allStationsDescription: "លទ្ធផលទាញយកត្រូវបានរក្សាទុកក្នុងប្រវត្តិនាំចេញនៃផ្ទាំងនេះ ហើយអ្នកអាចទាញយក CSV និង DXF ពីទីនោះ។",
      confirmTitle: "ទាញយកស្ថានីយទាំងអស់",
      confirmMessage: "អ្នកអាចទាញយកលទ្ធផលពីប្រវត្តិនាំចេញក្នុងផ្ទាំងនេះ។",
      stationCount: "ស្ថានីយ",
      start: "ចាប់ផ្ដើមទាញយក",
      started: "បានចាប់ផ្ដើមទាញយកស្ថានីយទាំងអស់។",
      tooLargeSectionLength: "ការនាំចេញធំពេក — {{axis}} {{actual}} / អតិបរមា {{maximum}}។ សូមពង្រីកចន្លោះផ្នែកឆ្លង បង្រួមជួរខ្សែ ឬការកំណត់ទទឹង ឬបន្ថយស្រទាប់ដែលបើក។",
      tooLargeSamples: "ការនាំចេញធំពេក — {{axis}} {{actual}} / អតិបរមា {{maximum}}។ សូមពង្រីកគម្លាតចំណុច ឬចន្លោះផ្នែកឆ្លង បង្រួមជួរខ្សែ ឬការកំណត់ទទឹង ឬបន្ថយស្រទាប់ដែលបើក។",
      tooLargeUnknownAxis: "ការនាំចេញធំពេក — {{axis}} {{actual}} / អតិបរមា {{maximum}}។",
      axisSectionLength: "ប្រវែងផ្នែកសរុប (m) × ចំនួនស្រទាប់",
      axisSamples: "ចំនួនចំណុចសរុប",
      inProgress: "ការទាញយកស្ថានីយទាំងអស់សម្រាប់ចំណារពន្យល់នេះកំពុងដំណើរការរួចហើយ។ សូមពិនិត្យនៅប្រវត្តិនាំចេញ។",
      capacityReached: "ពេលនេះមានការទាញយកស្ថានីយទាំងអស់ច្រើនពេក។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ។",
      startFailed: "មិនអាចចាប់ផ្ដើមការទាញយកស្ថានីយទាំងអស់បានទេ។",
      fileSuffix: "ទាំងអស់",
    },
    exportHistory: {
      title: "ប្រវត្តិនាំចេញ",
      buttonRunning: "ប្រវត្តិនាំចេញ · {{percent}}%",
      buttonCompleted: "ប្រវត្តិនាំចេញ · រួចរាល់",
      buttonFailed: "ប្រវត្តិនាំចេញ · បរាជ័យ",
      empty: "អ្នកអាចទាញយកលទ្ធផលនៃការទាញយកស្ថានីយទាំងអស់នៅទីនេះ។",
      loadFailed: "មិនអាចផ្ទុកប្រវត្តិនាំចេញបានទេ។",
      summary: "ស្ថានីយ {{stations}} · គម្លាតចំណុច {{step}} m · ស្រទាប់ {{series}}",
      sectionSettings: "ផ្នែក {{first}}–{{last}} · ចំណុចស្ទង់ចាប់ផ្ដើម {{start}} m · ចន្លោះផ្នែកឆ្លង {{interval}} m · ឆ្វេង/ស្តាំ {{left}}/{{right}} m",
      completed: "រួចរាល់",
      failed: "បរាជ័យ",
      detailsLabel: "ព័ត៌មានលម្អិតនៃការនាំចេញ {{time}} ({{status}})",
      progressLabel: "វឌ្ឍនភាពទាញយកស្ថានីយទាំងអស់",
      downloadCsv: "ទាញយក CSV នៃការនាំចេញ {{time}}",
      downloadDxf: "ទាញយក DXF នៃការនាំចេញ {{time}}",
      delete: "លុប",
      deleteLabel: "លុបការនាំចេញ {{time}}",
      notFound: "រកមិនឃើញការនាំចេញនេះទេ។",
      downloadFailed: "មិនអាចបង្កើតឯកសារបានទេ។",
      deleteFailed: "មិនអាចលុបការនាំចេញបានទេ។",
    },
  },
  report: {
    title: "របាយការណ៍",
    create: "បង្កើតរបាយការណ៍",
    export: "នាំចេញរបាយការណ៍",
    formTitle: "ចំណងជើង",
    titlePlaceholder: "សូមបញ្ចូលចំណងជើងរបាយការណ៍",
    author: "អ្នកនិពន្ធ",
    authorPlaceholder: "សូមបញ្ចូលឈ្មោះអ្នកនិពន្ធ",
    organization: "ស្ថាប័ន",
    job: "តួនាទី",
    email: "អ៊ីមែល",
    phone: "H.P",
  },
  vector: {
    title: "វ៉ិចទ័រ",
    totalCount: "សរុប {{count}}",
    showOnMap: "បង្ហាញលើផែនទី",
    create: {
      sectionTitle: "បង្កើតវ៉ិចទ័រ",
      open: "បង្កើតដោយបញ្ចូលកូអរដោនេ",
      name: "ឈ្មោះ",
      namePlaceholder: "ឈ្មោះវ៉ិចទ័រ",
      modeLngLat: "រយៈទទឹង/រយៈបណ្ដោយ",
      modeProjectCrs: "កូអរដោនេ X/Y",
      lng: "រយៈបណ្ដោយ",
      lat: "រយៈទទឹង",
      x: "X",
      y: "Y",
      elHeight: "កម្ពស់ (m)",
      color: "ពណ៌",
      radius: "កាំ (m)",
      shape: "រូបរាង",
      shape_line: "បន្ទាត់",
      shape_cylinder: "ស៊ីឡាំង",
      shape_square: "សសរការេ",
      side: "ជ្រុង (m)",
      shapeLineNoSize: "បន្ទាត់គ្មានទំហំ",
      radiusValueHint: "បញ្ចូលតម្លៃ",
      commentPlaceholder: "បញ្ចូលកំណត់ចំណាំ (ស្រេចចិត្ត)",
      addPoint: "បន្ថែមចំណុច",
      submit: "បង្កើត",
      epsgUnavailable: "មិនអាចកំណត់ប្រព័ន្ធកូអរដោនេគម្រោងបានទេ។",
      createFailed: "បង្កើតវ៉ិចទ័របរាជ័យ។",
    },
    list: {
      sectionTitle: "បញ្ជីវ៉ិចទ័រ",
      empty: "មិនទាន់មានវ៉ិចទ័រទេ។",
      emptyDesc: "បញ្ចូលកូអរដោនេខាងលើដើម្បីបង្កើត។",
      loading: "កំពុងផ្ទុកវ៉ិចទ័រ…",
      loadFailed: "បរាជ័យក្នុងការផ្ទុកវ៉ិចទ័រ។",
      retry: "ព្យាយាមម្តងទៀត",
      radius: "កាំ (m)",
      line: "បន្ទាត់",
      radiusValue: "{{symbol}} {{value}}m",
      pointCount: "ចំណុច {{count}}",
      delete: "លុប",
      deletePoints: "លុបចំណុច",
      deleteConfirmTitle: "លុបវ៉ិចទ័រ",
      deleteConfirmMessage: "លុបវ៉ិចទ័រ '{{name}}' ឬ?",
      deleteIrreversible: "មិនអាចត្រឡប់វិញបានទេ។",
      deleteFailed: "លុបវ៉ិចទ័របរាជ័យ។",
      updateFailed: "កែប្រែវ៉ិចទ័របរាជ័យ។",
      infoSection: "ព័ត៌មាន",
      coordinates: "បញ្ជីកូអរដោនេ",
      perpendicular: "មុខកាត់កែង",
      save: "រក្សាទុក",
      reset: "កំណត់ឡើងវិញ",
    },
    perpendicular: {
      title: "មុខកាត់កែង",
      position: "ទីតាំងកាត់ (ពីចំណុចចាប់ផ្ដើម, m)",
      totalLength: "ប្រវែងសរុប {{length}}m",
      meterUnit: "m",
      positionRange: "ទីតាំងកាត់ត្រូវនៅចន្លោះ 0 និងប្រវែងសរុប។",
      length: "ប្រវែងបន្ទាត់កាត់ (m)",
      confirm: "យល់ព្រម",
      lengthRange: "ប្រវែងត្រូវធំជាង 0 និងមិនលើស 1000។",
      invalid:
        "មិនអាចគណនាបន្ទាត់កាត់បានទេ។\nវ៉ិចទ័របញ្ឈរ ឬចំណុចតែមួយ មិនអាចបង្កើតផ្នែកកាត់បានទេ។",
    },
    selection: {
      selectDelete: "លុប",
      selectAll: "ជ្រើសទាំងអស់",
      deselectAll: "ដកការជ្រើសទាំងអស់",
      confirm: "បញ្ជាក់",
      confirmMessage: "លុបវ៉ិចទ័រ {{count}}?",
      minPointsHint: "ត្រូវរក្សាទុកចំណុចយ៉ាងហោចណាស់ {{count}}",
    },
    errors: {
      nameLength: "ឈ្មោះត្រូវមានពី {{nameMin}} ដល់ {{nameMax}} តួអក្សរ។",
      commentLength: "កំណត់ចំណាំត្រូវមិនលើសពី {{commentMax}} តួអក្សរ។",
      minPoints: "ត្រូវការចំណុចយ៉ាងតិច {{minPoints}}។",
      maxPoints: "អាចបញ្ចូលចំណុចបានច្រើនបំផុត {{maxPoints}}។",
      notNumber: "សូមបញ្ចូលលេខ។",
      lngRange: "រយៈបណ្ដោយត្រូវនៅចន្លោះ {{lngMin}} ដល់ {{lngMax}}។",
      latRange: "រយៈទទឹងត្រូវនៅចន្លោះ {{latMin}} ដល់ {{latMax}}។",
      radiusRange: "កាំត្រូវនៅចន្លោះ {{sizeExclusiveMin}} និង {{maxRadius}}.",
      sideRange: "ជ្រុងត្រូវនៅចន្លោះ {{sizeExclusiveMin}} និង {{maxSide}}.",
    },
  },
  geoLog: {
    title: "រូបភាព·វីដេអូ",
    totalCount: "សរុប {{count}}",
    showOnMap: "បង្ហាញលើផែនទី",
    noFilesHint: "ឯកសារនឹងបង្ហាញនៅពេលផែនទីផ្ទុករួច។",
    emptyFiles: "មិនមានរូបภាព·វីដេអូដែលបានចុះបញ្ជី។",
    noPosition: "គ្មានទីតាំង",
    groupCount: "{{count}}",
    locationGroup: {
      noPositionDesc: "រូបភាពទាំងនេះមិនទាន់បង្ហាញលើផែនទីទេ។",
    },
    uncategorized: "មិនបានចាត់ថ្នាក់",
    noCaptureDate: "គ្មានកាលបរិច្ឆេទ",
    uploaderMe: "ខ្ញុំ",
    groupEdit: {
      title: "កែក្រុមរួមគ្នា",
      label: "កែក្រុមរួមគ្នា",
      titleField: "កែ {{field}} ទាំងអស់",
      desc: "អនុវត្ត {{field}} ដូចគ្នាទៅរូបភាព {{count}} សន្លឹកក្នុងក្រុមនេះ។",
    },
    view: {
      captureDate: "តាមថ្ងៃថត",
      category: "តាមប្រធានបទ",
      uploader: "តាមអ្នកបញ្ចូល",
      locationName: "តាមទីតាំង",
    },
    sort: {
      latest: "ថ្មីបំផុត",
      oldest: "ចាស់បំផុត",
    },
    position: {
      modalTitle: "កំណត់ទីតាំង",
      placeCard: "កំណត់ទីតាំង",
      placeHint: "ដាក់លើផែនទី",
      clearCard: "ដកទីតាំង",
      clearHint: "ដកទីតាំង",
      attachCard: "បន្ថែមទៅទីតាំងមាន",
      attachHint: "បញ្ចូលទៅទីតាំងមាន",
      unnamedLocation: "ទីតាំងគ្មានឈ្មោះ",
      existingCount: "មាន {{count}}",
      addAction: "បន្ថែមទីនេះ",
      selectTargetHint:
        "អ្នកអាចបន្ថែមរូបទៅទីតាំងដែលមានស្រាប់។\nសូមជ្រើសទីតាំងមានស្រាប់ជាមុនសិន។",
      placeStepHint:
        "ចុចលើកន្លែងទំនេរសម្រាប់ទីតាំងថ្មី ឬចុចលើ marker ដែលមានស្រាប់ដើម្បីបន្ថែមទៅទីនោះ។\nសូមជ្រើសរូបដែលត្រូវកំណត់ទីតាំង។",
      clearStepHint:
        "អ្នកអាចដកទីតាំងដែលបានកំណត់លើរូប។\nសូមជ្រើសរូបដែលត្រូវដកទីតាំង។",
      attachStepHint:
        "អ្នកអាចប្រមូលរូបដែលជ្រើសទៅទីតាំងនេះ។\nសូមជ្រើសរូបដែលត្រូវបន្ថែមនៅទីនេះ។",
      noLocation: "គ្មានទីតាំង",
      back: "ត្រឡប់",
      selectAll: "ជ្រើសទាំងអស់",
      deselectAll: "ដកការជ្រើស",
      placeEmpty: "គ្មានរូបដែលគ្មានទីតាំង",
      clearEmpty: "គ្មានរូបដែលមានទីតាំង",
    },
    toolbar: {
      upload: "បញ្ចូល",
      place: "កំណត់ទីតាំង",
      delete: "លុប",
      download: "ទាញយក",
    },
    upload: {
      modalTitle: "បញ្ចូល",
      fileCard: "បញ្ចូលឯកសារ",
      fileCardHint: "ជ្រើសឯកសារពីឧបករណ៍",
      folderCard: "បញ្ចូលថត",
      folderCardHint: "ជ្រើសថតទាំងមូល",
      mapCard: "បញ្ចូលលើផែនទី",
      mapCardHint: "អូសទម្លាក់លើផែនទី",
      dropZoneHint: "ឬអូសឯកសារ·ថតមកទីនេះ",
      dropActive: "ទម្លាក់ទីនេះដើម្បីបញ្ចូល",
      sizeLimit: "អាចបញ្ចូលបានរហូតដល់ {{limit}} ក្នុងមួយលើក",
      uploading: "កំពុងបញ្ចូល...",
      uploadingShort: "កំពុងបញ្ចូល",
      queued: "កំពុងរង់ចាំ",
      cancel: "បោះបង់",
    },
    selection: {
      count: "បានជ្រើស {{count}}",
      selectGroup: "ជ្រើសក្រុមទាំងមូល",
      confirm: "ដាក់លើផែនទី",
      deleteTitle: "លុបឯកសារ",
      deleteIrreversible: "ឯកសារដែលបានលុបមិនអាចសង្គ្រោះបានទេ។",
      delete: "លុប",
      cancel: "បោះបង់",
      clear: "ដកទីតាំង",
      deleteConfirm: "លុបឯកសារដែលបានជ្រើស {{count}} មែនទេ?",
      download: "ទាញយក",
      selectDelete: "លុបអ្វីដែលបានជ្រើស",
      selectDownload: "ទាញយកអ្វីដែលបានជ្រើស",
      downloadTitle: "ទាញយកឯកសារ",
      downloadConfirm: "ទាញយកឯកសារដែលបានជ្រើស {{count}} មែនទេ?",
    },
    edit: {
      date: "កាលបរិច្ឆេទ",
      category: "ប្រធានបទ",
      categoryPlaceholder: "ជ្រើស ឬវាយប្រធានបទ",
      locationName: "ឈ្មោះទីតាំង",
      locationNamePlaceholder: "ឧ. សសរទី១, ច្រកខាងកើត",
      save: "រក្សាទុក",
      reset: "ត្រឡប់ដើម",
      cancel: "បោះបង់",
    },
    cell: {
      moveToPosition: "ទៅកាន់ទីតាំង",
      setPosition: "កំណត់ទីតាំង",
      detail: "មើលលម្អិត",
      moveToPositionAria: "ទៅកាន់ទីតាំងរបស់ {{name}}",
      setPositionAria: "កំណត់ទីតាំងសម្រាប់ {{name}}",
      detailAria: "មើលលម្អិត {{name}}",
    },
    detail: {
      uploader: "អ្នកបញ្ចូល",
      fileSize: "ទំហំ",
      locationJoinPlaceholder: "ជ្រើសឈ្មោះទីតាំងដែលមាន",
      locationJoinHint:
        "រក្សាទុកទៅទីតាំងដែលមានស្រាប់ — ទីតាំងថ្មីប្រើប៊ូតុង 'កំណត់ទីតាំង' ខាងលើ",
      locationMoveHint: "មានតែរូបនេះប៉ុណ្ណោះដែលផ្លាស់ទៅទីតាំងដែលបានជ្រើស",
      locationAssignHint: "រក្សាទុកជាឈ្មោះទីតាំងថ្មីនៅទីតាំងបច្ចុប្បន្ន",
      locationRenameGuide:
        "ឈ្មោះទីតាំងជារបស់ទីតាំង។ ប្តូរឈ្មោះនៅកាតមើលមុនលើផែនទី ឬការកែក្រុមក្នុងទិដ្ឋភាពតាមទីតាំងនៅរបារចំហៀង — អនុវត្តលើរូបទាំងអស់នៅទីតាំងនោះ",
      captureDate: "កាលបរិច្ឆេទថត",
      category: "ប្រធានបទ",
      locationName: "ឈ្មោះទីតាំង",
      viewPosition: "មើលទីតាំង",
      viewPositionShort: "មើល",
      movePosition: "ផ្លាស់ទី",
      movePositionAria: "ផ្លាស់ទីទីតាំង",
      expand: "ពង្រីកមើល",
      collapse: "បង្រួមមើល",
    },
    pano: {
      view360: "360°",
      viewFlat: "2D",
      resetView: "ទិដ្ឋភាពដំបូង",
      play: "ចាក់",
      pause: "ផ្អាក",
      mute: "បិទសំឡេង",
      unmute: "បើកសំឡេង",
      seek: "ទីតាំងចាក់",
    },
    roadview: {
      label: "ដំណើរទស្សនា",
      enter: "ដំណើរទស្សនា",
      exit: "បញ្ចប់ដំណើរទស្សនា",
      previous: "ចំណុចមុន",
      next: "ចំណុចបន្ទាប់",
      moveToPoint: "ទៅកាន់ចំណុចទី {{ordinal}}",
      progress: "{{current}} / {{total}}",
      miniMap: "ផែនទីតូចនៃវគ្គ",
      departedPoint: "ចំណុចមុន",
      currentPoint: "ចំណុចបច្ចុប្បន្ន",
      departedDirection: "ទិសដៅចំណុចមុន",
      relation: {
        previous: "ចំណុចមុន",
        next: "ចំណុចបន្ទាប់",
        spatial: "ចំណុចជិតខាង",
      },
      compass: {
        n: "ជើង",
        ne: "ជើងកើត",
        e: "កើត",
        se: "ត្បូងកើត",
        s: "ត្បូង",
        sw: "ត្បូងលិច",
        w: "លិច",
        nw: "ជើងលិច",
      },
      dualFisheye: "រូបភាពដើមមិនទាន់បានផ្សំ ដូច្នេះមិនអាចបើកជា 360° បានទេ",
    },
    card: {
      close: "បិទ",
      previewClose: "បិទការមើលជាមុន",
      loadFailed: "មិនអាចផ្ទុកបានទេ",
      unplayableVideo: "កម្មវិធីរុករកនេះមិនអាចចាក់ទម្រង់វីដេអូនេះបានទេ។ សូមទាញយកដើម្បីមើល។",
      download: "ទាញយក",
      deleteFile: "លុបឯកសារ",
      deleteFileConfirm: "លុបឯកសារនេះមែនទេ?",
      deleteScopePrompt: "លុបមួយណា?",
      scopePrompt: {
        place: "កែទីតាំងសម្រាប់?",
        clear: "ដកទីតាំងសម្រាប់?",
      },
      clearAllConfirm: "ដកទីតាំងរូបភាពទាំង {{count}} នៅទីតាំងនេះមែនទេ?",
      scopeThis: "តែរូបនេះ",
      scopeAll: "ទាំង {{count}}",
      positionSetting: "ទីតាំង",
      editPosition: "កែទីតាំង",
      editPositionShort: "កែ",
      editLocationName: "កែឈ្មោះទីតាំង",
      clearPosition: "ដកទីតាំង",
      clearPositionShort: "ដក",
      clearPositionConfirm: "ដកទីតាំងនេះមែនទេ?",
      release: "ដក",
      delete: "លុប",
      cancel: "បោះបង់",
      detail: "មើលលម្អិត",
      prevFile: "ឯកសារមុន",
      nextFile: "ឯកសារបន្ទាប់",
      addHere: "បន្ថែមរូបនៅទីនេះ",
      addPhoto: "បន្ថែមរូប",
      addPhotoShort: "បន្ថែម",
      addHereSelect: "ជ្រើសឯកសារបន្ថែមនៅទីនេះ ({{count}})",
    },
    marker: {
      placeHint:
        "ចុចលើផែនទីដើម្បីកំណត់ទីតាំង · ចុច marker ដែលមានស្រាប់ដើម្បីបន្ថែមទៅទីនោះ",
      mapUploadHint: "អូសឯកសារ·ថតទៅទីតាំងដែលអ្នកចង់បានលើផែនទី",
      rightClickCancel: "ចុចស្ដាំដើម្បីបោះបង់",
      single: "សញ្ញា {{name}}",
      cluster: "សញ្ញារូបភាព·វីដេអូ {{count}}",
      addToHere: "បន្ថែម {{name}} នៅទីនេះ",
    },
    notice: {
      onlyGeoLog: "អាចបញ្ចូលបានតែឯកសាររូបភាព·វីដេអូប៉ុណ្ណោះ",
      emptyFile: "មិនអាចបញ្ចូលឯកសារទទេបានទេ",
      excludedNonGeoLog: "បានដកឯកសារមិនមែនមេឌៀ {{count}} ចេញ",
      dropOnModel: "សូមទម្លាក់លើគំរូ",
      placeFailed: "បរាជ័យក្នុងការកំណត់ទីតាំង",
      uploadFailed: "បរាជ័យក្នុងការបញ្ចូល",
      alreadyUploading: "បានរំលងឯកសារ {{count}} ដែលកំពុងបញ្ចូលរួចហើយ",
      uploadTooLarge: "លើសទំហំ {{limit}} ដែលអាចបញ្ចូលក្នុងមួយលើក",
      quotaExceeded: "មិនអាចបញ្ចូលបានទេ៖ ទំហំសរុបលើស {{limit}}",
      usageUnknown: "មិនអាចពិនិត្យទំហំផ្ទុកបានទេ ដូច្នេះមិនអាចបញ្ចូលបាន",
      partialExcluded: "បញ្ចូលដោយដកឯកសារ {{count}} ចេញ ({{detail}})",
      allExcluded: "គ្មានឯកសារអាចបញ្ចូលបានទេ ({{detail}})",
      excludeReason: {
        empty: "0 បៃ",
        nonMedia: "ទម្រង់មិនគាំទ្រ",
        invalidName: "ឈ្មោះឯកសារខុស",
        tooLarge: "ធំពេក",
      },
      deleteFailed: "បរាជ័យក្នុងការលុបឯកសារ",
      listFailed: "បរាជ័យក្នុងការផ្ទុកបញ្ជី",
      clearFailed: "បរាជ័យក្នុងការដកទីតាំង",
      addFailed: "បរាជ័យក្នុងការបន្ថែមរូប",
      updateMetaFailed: "បរាជ័យក្នុងការកែព័ត៌មាន",
      updateMetaSaved: "បានរក្សាទុក",
      downloadFailed: "បរាជ័យក្នុងការទាញយក",
      loadFailed: "បរាជ័យក្នុងការផ្ទុកបញ្ជី",
      retry: "ព្យាយាមម្តងទៀត",
    },
    scope: {
      drawArea: "តម្រងតំបន់",
      addArea: "បន្ថែមតំបន់",
      hint: "គូរតំបន់លើផែនទី ឬចុចលើសញ្ញា ដើម្បីមើលតែរូបភាព·វីដេអូក្នុងតំបន់នោះ។ ចុចលើតំបន់នៅលើផែនទីម្តងទៀត ដើម្បីដកវាចេញពីតំបន់ដែលបានជ្រើសរើស។",
      help: "ជំនួយអំពីតម្រងតំបន់",
      areas: "តំបន់ចំនួន {{count}}",
      areaLabel: "តំបន់ {{n}}",
      count: "{{count}} / {{total}}",
      countAria: "បង្ហាញ {{count}} នៃ {{total}}",
      drawing: "កំពុងគូរតំបន់…",
      drawCancel: "បោះបង់ការគូរ",
      drawingHint: "អូសលើផែនទីដើម្បីគូរតំបន់។ ចុច ESC ឬចុចស្ដាំដើម្បីបោះបង់។",
      dragOnGround: "សូមគូរឱ្យជ្រុងទាំងបួនស្ថិតនៅលើដី",
      flyTo: "ទៅកាន់តំបន់",
      clear: "ជម្រះតម្រង",
      empty: "គ្មានរូបភាព·វីដេអូក្នុងតំបន់ដែលបានជ្រើសរើសទេ",
      emptyHint: "គូរតំបន់ផ្សេងទៀត ឬត្រឡប់ទៅបញ្ជីទាំងអស់",
      emptyNoPositioned:
        "គ្មានរូបភាព·វីដេអូដែលមានទីតាំងទេ។ កំណត់ទីតាំងក្នុងក្រុមខាងក្រោម",
      showAll: "បង្ហាញទាំងអស់",
      unpositionedTag: "មិនពាក់ព័ន្ធនឹងវិសាលភាព",
      unpositionedDesc: "នៅពេលកំណត់ទីតាំង វានឹងបង្ហាញក្នុងបញ្ជីតាមវិសាលភាព",
      placedOutside: "បានកំណត់នៅក្រៅតំបន់ ដូច្នេះមិនបង្ហាញក្នុងបញ្ជីទេ",
      dropWhileDrawing: "មិនអាចផ្ទុកឡើងបានទេ ខណៈកំពុងគូរតំបន់",
    },
    usage: {
      title: "ទំហំប្រើប្រាស់",
    },
  },
  equipment: {
    menu: "ឧបករណ៍ និងសំណង់",
    title: "ឧបករណ៍ និងសំណង់",
    totalCount: "សរុប {{count}}",
    showOnMap: "បង្ហាញលើផែនទី",
    listLabel: "ឧបករណ៍ និងសំណង់",
    add: "បន្ថែមឧបករណ៍",
    addFolder: "បន្ថែមថត",
    captureView: "ថតអេក្រង់",
    captureFormat: "ទ្រង់ទ្រាយរូបភាព",
    loading: "កំពុងផ្ទុកឧបករណ៍",
    loadFailedTitle: "មិនអាចផ្ទុកឧបករណ៍បានទេ",
    loadFailedDesc: "សូមព្យាយាមម្តងទៀតក្នុងពេលបន្តិចទៀត។",
    refreshFailed: "មិនអាចធ្វើបច្ចុប្បន្នភាពបញ្ជីឧបករណ៍បានទេ",
    dock: {
      label: "ឧបករណ៍ និងសំណង់",
      close: "បិទបញ្ជីឧបករណ៍",
      collapse: "បង្រួម",
      all: "ទាំងអស់",
      categories: "ប្រភេទឧបករណ៍",
      types: "ប្រភេទឧបករណ៍",
      prev: "ឧបករណ៍មុន",
      next: "ឧបករណ៍បន្ទាប់",
      loadFailed: "មិនអាចផ្ទុកប្រភេទឧបករណ៍បានទេ",
      refreshFailed: "មិនអាចធ្វើបច្ចុប្បន្នភាពប្រភេទឧបករណ៍បានទេ",
      empty: "មិនមានឧបករណ៍ដែលអាចបន្ថែមបានទេ",
    },
    catalog: {
      category: {
        lifting: "លើក និងកម្ពស់",
        earthwork: "ការងារដី និងដឹកជញ្ជូន",
        temporary: "សំណង់បណ្ដោះអាសន្ន",
        material: "សម្ភារៈ",
        labor: "កម្លាំងពលកម្ម",
      },
      type: {
        towerCrane: "ស្ទូចប៉ម",
        mobileCrane: "ស្ទូចចល័ត",
        aerialPlatform: "វេទិកាការងារលើខ្ពស់",
        excavator: "ម៉ាស៊ីនជីក",
        dumpTruck: "ឡានចាក់ដី",
        mixerTruck: "ឡានលាយបេតុង",
        loader: "ម៉ាស៊ីនលើកដី",
        roller: "ម៉ាស៊ីនបង្ហាប់",
        concretePump: "ឡានបូមបេតុង",
        drillRig: "ម៉ាស៊ីនខួង",
        forklift: "ឡានលើកទំនិញ",
      },
    },
    intro: {
      title: "សាកល្បងផ្លាស់ទីឧបករណ៍ជាមុន",
      riskTag: "គ្រោះថ្នាក់",
      speedTag: "{{speed}} km/h",
      realSizeTitle: "ទំហំពិត",
      realSizeDesc: "ដាក់ជាម៉ូដែលទំហំពិត",
      reachTitle: "ពិនិត្យកាំការងារ",
      reachDesc: "ពិនិត្យកាំត្រួតគ្នាជាមុន",
      simulationTitle: "ការក្លែងធ្វើ",
      simulationDesc: "ផ្លាស់ទីតាមផ្លូវ និងល្បឿន",
    },
    list: {
      risk: "គ្រោះថ្នាក់ {{count}}",
      toggleVisibility: "បង្ហាញ {{name}} លើផែនទី",
      expand: "ពង្រីក {{name}}",
      rowMenu: "ច្រើនទៀតសម្រាប់ {{name}}",
      visibilityFailed:
        "មិនអាចប្ដូរការបង្ហាញលើផែនទីបានទេ។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ",
      moveTo: "ទៅកាន់ទីតាំង",
      rename: "ប្ដូរឈ្មោះ",
      delete: "លុប",
      duplicate: "ចម្លង",
      duplicateSuffix: " (ច្បាប់ចម្លង)",
      duplicateFailed: "មិនអាចចម្លងបានទេ។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ",
      duplicateFolderFailed: "មិនអាចចម្លងថតបានទេ។ សូមព្យាយាមម្ដងទៀតនៅពេលក្រោយ",
      deleteFolderFailed: "មិនអាចលុបថតបានទេ។ សូមព្យាយាមម្ដងទៀតនៅពេលក្រោយ",
      captureFailed: "មិនអាចថតអេក្រង់បានទេ។ សូមព្យាយាមម្ដងទៀតនៅពេលក្រោយ",
      renameInput: "ឈ្មោះរបស់ {{name}}",
      renameConfirm: "រក្សាទុកឈ្មោះរបស់ {{name}}",
      renameCancel: "បោះបង់ការប្ដូរឈ្មោះ {{name}}",
      renameFailed: "មិនអាចប្ដូរឈ្មោះបានទេ។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ",
      deleteFailed: "មិនអាចលុបឧបករណ៍បានទេ។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ",
      deleteTitle: "លុបឧបករណ៍",
      deleteMessage: "លុប '{{name}}' ឬ?",
      deleteSubMessage: "ឧបករណ៍ដែលបានលុបមិនអាចស្ដារវិញបានទេ។",
      deleteCancel: "បោះបង់",
      deleteConfirm: "លុប",
    },
    detail: {
      tabs: "ព័ត៌មានលម្អិត {{name}}",
      tab: {
        spec: "លក្ខណៈ",
        position: "ទីតាំង·ទិស",
        route: "ផ្លូវធ្វើដំណើរ",
      },
      cancel: "បោះបង់",
      apply: "អនុវត្ត",
      position: "ទីតាំង",
      moveOnMap: "ផ្លាស់ទីលើផែនទី",
      longitude: "រយៈបណ្តោយ",
      latitude: "រយៈទទឹង",
      altitude: "កម្ពស់",
      heading: "ទិសដៅមុខ",
      headingInput: "ទិសដៅមុខ (ដឺក្រេ)",
      moving: "កំពុងផ្លាស់ទី",
      origin: "ទីតាំងដើម",
      specFailed: "មិនអាចរក្សាទុកលក្ខណៈបានទេ។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ",
      headingFailed: "មិនអាចរក្សាទុកទិសបានទេ។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ",
      moveFailed: "មិនអាចផ្លាស់ទីបានទេ។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ",
    },
    route: {
      emptyTitle: "មិនទាន់មានផ្លូវធ្វើដំណើរទេ",
      emptyBody: "ចុចចំណុចលើផែនទី ដើម្បីគូរផ្លូវ។",
      draw: "គូរផ្លូវធ្វើដំណើរ",
      drawing: "កំពុងគូរផ្លូវធ្វើដំណើរ",
      editing: "កំពុងកែផ្លូវធ្វើដំណើរ",
      cancel: "បោះបង់",
      done: "រួចរាល់",
      distance: "ចម្ងាយ",
      points: "ចំណុច",
      pointsLimit: "ផ្លូវអាចមានចំណុចបានអតិបរមា {{max}}",
      duration: "រយៈពេលប៉ាន់ស្មាន",
      meters: "{{distance}} m",
      play: "ចាក់ផ្លូវធ្វើដំណើរ",
      pause: "ផ្អាក",
      repeat: "ចាក់ឡើងវិញដដែលៗ",
      repeatShort: "ដដែលៗ",
      position: "ទីតាំងចាក់",
      positionValue: "{{elapsed}} / {{total}}",
      speed: "ល្បឿន",
      speedSlider: "ល្បឿនចាក់",
      simulation: "ការក្លែងធ្វើផ្លូវ",
      speedUnit: "km/h",
      edit: "កែ",
      delete: "លុប",
      locked: "ផ្អាកការចាក់ផ្លូវ ដើម្បីកែប្រែ។",
      deleteTitle: "លុបផ្លូវធ្វើដំណើរ",
      deleteMessage: "លុបផ្លូវធ្វើដំណើររបស់ '{{name}}' មែនទេ?",
      deleteSubMessage: "ផ្លូវធ្វើដំណើរដែលបានលុបមិនអាចស្ដារវិញបានទេ។",
      deleteCancel: "បោះបង់",
      deleteConfirm: "លុប",
      saveFailed: "មិនអាចរក្សាទុកផ្លូវធ្វើដំណើរបានទេ។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ",
      deleteFailed: "មិនអាចលុបផ្លូវធ្វើដំណើរបានទេ។ សូមព្យាយាមម្ដងទៀតបន្តិចក្រោយ",
    },
    placement: {
      createFailed: "មិនអាចដាក់ឧបករណ៍បានទេ។ សូមព្យាយាមម្តងទៀតនៅពេលក្រោយ",
      name: "ឈ្មោះ",
      spec: "លក្ខណៈបច្ចេកទេសគោល",
      custom: "បញ្ចូលដោយខ្លួនឯង",
      dimensions: "វិមាត្រ",
      length: "បណ្ដោយ",
      width: "ទទឹង",
      height: "កម្ពស់",
      reach: "កាំការងារ",
      unit: "m",
      radiusColor: "ពណ៌កាំ",
      radiusColorDisabled: "អាចជ្រើសបាននៅពេលមានកាំការងារ",
      close: "បិទ",
      place: "ដាក់",
      error: {
        nameRequired: "សូមបញ្ចូលឈ្មោះ",
        nameTooLong: "ឈ្មោះអាចមានរហូតដល់ {{max}} តួអក្សរ",
        dimensionRange: "សូមបញ្ចូលតម្លៃធំជាង 0 និងមិនលើស {{max}}",
        reachRange: "សូមបញ្ចូល 0–{{max}} ឬទុកឱ្យទទេ",
      },
    },
    radiusColor: {
      peach: "ពណ៌ប៉ែស",
      lemon: "ពណ៌ក្រូចឆ្មា",
      mint: "ពណ៌មីន",
      lavender: "ពណ៌ឡាវេនឌ័រ",
      pink: "ពណ៌ផ្កាឈូក",
    },
  },
} as const;

export default timeSeries;
